const getShowCountVehiclesNumber = (
  pageSize: number,
  totalResultCount: number,
  isLastPage: boolean
) => {
  let vehiclesPerPage = pageSize;
  if (isLastPage && totalResultCount % pageSize !== 0)
    vehiclesPerPage = totalResultCount % pageSize;
  if (totalResultCount < vehiclesPerPage) {
    vehiclesPerPage = totalResultCount;
  }
  return vehiclesPerPage;
};

export default getShowCountVehiclesNumber;
